import React from "react";
import { Link } from "react-router-dom";

import tmdbLogo from "../../assets/tmdb_logo.svg";
import { MovieItem } from "../../constants/interfaces";
import { posterUrl } from "../../constants/urls";

interface Props {
  movie: MovieItem;
  onClick: () => void;
}

const SearchedMovie: React.FC<Props> = (props) => {
  const { movie } = props;
  const posterImage = movie.poster ? `${posterUrl}${movie.poster}` : tmdbLogo;

  return (
    <Link to={`/movie/${movie.id}`} onClick={props.onClick}>
      <div className="searchedMovie">
        <img src={posterImage} className="searchedMovieImage" alt={movie.title} />
        <div className="ml-4 min-w-0">
          <p className="searchedMovieTitle defaultText">{movie.title}</p>
          <p className="text-cool-gray-500">{movie.releaseYear}</p>
        </div>
      </div>
    </Link>
  );
};

export default SearchedMovie;
